
import React from 'react';
import { Button } from '@/components/ui/button';
import { LucideIcon } from 'lucide-react';

interface ListingActionButtonProps {
  icon: LucideIcon;
  label: string;
  onClick: () => void;
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link' | 'darkOutline';
  className?: string;
}

const ListingActionButton = ({ 
  icon: Icon, 
  label, 
  onClick, 
  variant = 'secondary',
  className = 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
}: ListingActionButtonProps) => {
  return (
    <Button 
      variant={variant} 
      size="sm" 
      className={className}
      onClick={onClick}
    >
      <Icon className="mr-2 h-4 w-4" />
      {label}
    </Button>
  );
};

export default ListingActionButton;
